








































import {Component, Prop, Vue} from 'vue-property-decorator'
import {ValidationObserver} from 'vee-validate'
import {FlowInputField, FlowInputStep, FlowInputValidation} from '@/lib/kepler/interfaces'
import {State} from 'vuex-class'
import Utils from '@/utils'

@Component({
  components: {
    FlowField: Utils.loadComponent('flow/FlowField'),
    Icon: Utils.loadComponent('proxy/Icon'),
    Button: Utils.loadComponent('Button'),
    Card: Utils.loadComponent('proxy/Card/Card'),
    CloseButton: Utils.loadComponent('CloseButton'),
    Container: Utils.loadComponent('proxy/Container'),
    Layout: Utils.loadComponent('proxy/Layout'),
    Divider: Utils.loadComponent('proxy/Divider'),
    ValidationObserver,
  },
  name: 'RegistrationDocumentAddDialog',
})
export default class RegistrationDocumentAddDialog extends Vue {
  @State('flowOutputs') public flowOutputs!: { [k: string]: any }
  @Prop({
    type: Object,
    required: true,
  }) protected doc!: FlowInputStep
  @Prop({
    type: String || null,
    default: () => null,
  }) protected flowName!: string | null
  @Prop({
    type: Function,
  }) protected successCallback!: () => void
  @Prop({
    type: Function,
  }) protected cancelCallback!: () => void

  protected get attachmentFields() {
    return this.doc?.fields?.filter((f) => {
      return f.type === 'image'
    })
  }

  protected get docFields() {
    return this.doc?.fields?.filter((f) => {
      return f.type !== 'image'
    })
  }

  protected get output() {
    const atts = this.attachmentFields
    if (this.flowOutputs && this.flowName && this.doc?.id) {
      const docs = this.flowOutputs[this.flowName]?.documents
      if (docs) {
        const doc = docs[this.doc.id]
        if (doc) {
          const outputAtts = doc.attachments
          return atts?.map((att) => {
            return Object.keys(outputAtts).includes(att.name)
          })
        }
      }
    }
    return atts?.map(() => true)
  }

  protected saveAndClose(validate: () => Promise<boolean>) {
    validate().then((pass) => {
      if (pass) {
        this.successCallback()
      }
    })
    // TODO: something resets those fields on save
  }

  protected getMask(f: FlowInputField) {
    const v = f.validation
    let result
    if (v && (v.includes('mask') || (v as FlowInputValidation).mask)) {
      if (typeof v === 'string') {
        v.split('|').find((rule) => {
          const maskRegex = /mask:(.+)/
          const m = rule.match(maskRegex)
          if (m) {
            result = m[1]
          }
        })
      } else {
        result = v.mask
      }
    }
    return result
  }

  protected viewHasTranslation(view_name: string) {
    const str = view_name
      .replace('picture-', '')
    const trn = this.$isAvailable(
      `registration.driver_document.attachments_${str.replace(' ', '_')}`,
    )
    return trn || str
  }

}
